//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import isEmpty from 'lodash/isEmpty'

import { MOBILE } from '@/scripts/constants/media-query'
import { mapGetters, createNamespacedHelpers } from 'vuex'
import { FrameAdvisor } from '@/scripts/libs/frame-advisor'

const { mapGetters: mapGettersFrameGenius } = createNamespacedHelpers('frameGenius')

export default {
  name: 'rb-frame-genius-my-account',
  data() {
    return {
      suggestedFeatures: undefined,
    }
  },
  computed: {
    ...mapGetters(['translation']),
    ...mapGettersFrameGenius(['analysisResults']),
    getButtonLabel() {
      return this.isFrameGeniusDataPresent
        ? this.translation('frame_genius.my_account.browse_the_perfect_styles')
        : this.translation('frame_genius.my_account.try_frame_genius')
    },
    isMobile() {
      return this.$mq === MOBILE
    },
    isFrameGeniusDataPresent() {
      return !isEmpty(this.suggestedFeatures)
    },
  },
  watch: {
    analysisResults(newVal) {
      this.suggestedFeatures = newVal
    },
  },
  mounted() {
    this.suggestedFeatures = FrameAdvisor.getAnalysisResults()
  },
  methods: {
    openFrameGenius() {
      this.$ma.trackEvent({
        event: 'Click',
        value: {
          data_element_id: 'X_X_My_Details_FrameGenius_Open',
        },
      })
      window.triggerVueMethod('initFrameAdvisor')
    },
  },
}
